/**
 * letturaCartella.js — che cosa fa la cartella quando la lettura del
 * paziente fallisce (Claude, 3/11/2026). Una regola sola per i due stili
 * (PazienteDetail e PazienteDetailConsole).
 *
 * Fino a quel giorno ogni errore diceva «Paziente non trovato» e riportava
 * all'elenco, anche un 502: con i rilasci di giorno (un secondo e mezzo di
 * 502 al riavvio) un medico usciva dalla cartella in mezzo alla visita, e
 * la lettura si rifa' anche dopo ogni salvataggio o firma.
 *
 *   'elenco'   un rifiuto vero (404, 403, 400...): come prima;
 *   'resta'    la risposta non e' arrivata e la cartella a schermo e'
 *              proprio quella chiesta: resta, con un avviso;
 *   'riprova'  la risposta non e' arrivata e a schermo non c'e' quella
 *              cartella (si sta aprendo, o si passa a un altro paziente):
 *              il motivo e «Riprova», mai la cartella di un altro.
 */
import { eDiRete } from '../../utils/invioConTentativi';

export function esitoLetturaCartella(errore, pazienteAschermo, idChiesto) {
    if (!eDiRete(errore)) return 'elenco';
    if (pazienteAschermo && String(pazienteAschermo.id) === String(idChiesto)) return 'resta';
    return 'riprova';
}
